import ContentReportManagement from "../../modules/content-report-management/views/ContentReportManagement.vue";
import RouterViewRender from "../../utils/routes/router-view-render";

const ContentReportManagementRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "gestao-conteudo-relatorio",
      component: ContentReportManagement,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default ContentReportManagementRoutes;
